import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Warehouse, QrCode } from 'lucide-react';

export function CatalogTab({ catalog, showQR }) {
  return (
    <Card>
      <CardContent className="p-0">
        {catalog.length === 0 ? (
          <div className="h-64 flex flex-col items-center justify-center text-muted-foreground">
            <Warehouse size={48} className="mb-4 opacity-50" />
            <p>No catalog items</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-muted/50">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-medium">Code</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">Name</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">System</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">Category</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">UOM</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">Min Stock</th>
                  <th className="px-4 py-3 text-left text-sm font-medium">QR</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {catalog.map(function(c) {
                  var systemClass = c.system_type === 'ykk' ? 'bg-blue-100 text-blue-700' : c.system_type === 'unitized' ? 'bg-yellow-100 text-yellow-700' : 'bg-purple-100 text-purple-700';
                  return (
                    <tr key={c.id} className="hover:bg-muted/30">
                      <td className="px-4 py-3 font-mono text-sm">{c.item_code}</td>
                      <td className="px-4 py-3">{c.item_name}</td>
                      <td className="px-4 py-3">
                        <span className={'px-2 py-1 rounded text-xs ' + systemClass}>
                          {(c.system_type || '').toUpperCase()}
                        </span>
                      </td>
                      <td className="px-4 py-3 capitalize">{c.category}</td>
                      <td className="px-4 py-3">{c.uom}</td>
                      <td className="px-4 py-3">{c.minimum_stock_level}</td>
                      <td className="px-4 py-3">
                        <Button variant="ghost" size="sm" onClick={function() { showQR('catalog', c.id, c.item_code); }}>
                          <QrCode size={14} />
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
